
@if (entryApproved !== 'request' && entryApproved !== 'hasCode') {
    <app-show-demos [approval]="entryApproved" (requestAccess)="requestAccessEvent($event)"></app-show-demos>
} @else {
    <app-get-demo-access (backToVideos)="giveUp()" (enterRoom)="allowEntry()" [approval]="entryApproved"></app-get-demo-access>
}



